import { batch } from 'react-redux';

// project imports
import gestopAPI from 'utils/gestopAPI';
import { dispatch } from 'store/index';
import { errorProcessor } from 'utils/processors';
import { downloadFile } from 'ui-component/custom/FileMngr';
import { workOrderActions } from './slice';
import capabilities from './capabilities';

export const ApiWorkOrdersGetCollection = async ({
    filters = [],
    orderBy = [],
    groupBy = [],
    page = 1,
    limit = 10,
    includeSafeDeleted = false,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(workOrderActions.startLoading());
    }

    await gestopAPI
        .post('workmgmt/workorders/list', { filters, orderBy, groupBy, page, limit, includeSafeDeleted }, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(workOrderActions.setList(response?.data?.list));
                    dispatch(workOrderActions.setCount(response?.data?.count));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(workOrderActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data?.list);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(workOrderActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(workOrderActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiWorkOrdersCountCollection = async ({
    filters = [],
    includeSafeDeleted = false,
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post('workmgmt/workorders/count', { filters, includeSafeDeleted }, config)
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data?.count);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiWorkOrdersPostCollection = async ({
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(workOrderActions.startLoading());
    }

    await gestopAPI
        .post('workmgmt/workorders', data, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(workOrderActions.insertItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(workOrderActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(workOrderActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(workOrderActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiWorkOrdersDeleteCollection = async ({
    ids = [],
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(workOrderActions.startLoading());
    }

    await gestopAPI
        .post('workmgmt/workorders/safedelete', ids, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(workOrderActions.deleteItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(workOrderActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(workOrderActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(workOrderActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiWorkOrdersExportCollection = async ({
    exportType = 'allRows',
    format = 'pdf',
    columns = [],
    filters = [],
    orderBy = [],
    groupBy = [],
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    if (capabilities.app.includes('exporter')) {
        dispatch(workOrderActions.startExporting());
    }

    await gestopAPI
        .post('workmgmt/workorders/export', { exportType, format, columns, filters, orderBy, groupBy }, { ...config, responseType: 'blob' })
        .then((response) =>
            batch(() => {
                window.open(URL.createObjectURL(response?.data));

                if (capabilities.app.includes('exporter')) {
                    dispatch(workOrderActions.stopExporting());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('exporter')) {
                    dispatch(workOrderActions.stopExporting());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(workOrderActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiWorkOrdersPutItem = async ({
    id,
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(workOrderActions.startLoading());
    }

    await gestopAPI
        .put(`workmgmt/workorders/${id}`, data, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(workOrderActions.updateItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(workOrderActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(workOrderActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(workOrderActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiWorkOrdersPatchItem = async ({
    id,
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(workOrderActions.startLoading());
    }

    await gestopAPI
        .patch(`workmgmt/workorders/${id}`, data, {
            ...config,
            headers: { ...config?.headers, 'Content-Type': 'application/merge-patch+json' } // Specific content type for PATCH requests
        })
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(workOrderActions.updateItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(workOrderActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(workOrderActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(workOrderActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiWorkOrdersDeleteItem = async ({
    id,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(workOrderActions.startLoading());
    }

    await gestopAPI
        .post(`workmgmt/workorders/safedelete/${id}`, {}, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(workOrderActions.deleteItems(id));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(workOrderActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(workOrderActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(workOrderActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiWorkOrdersRestoreDeletedItem = async ({
    id,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(workOrderActions.startLoading());
    }

    await gestopAPI
        .post(`workmgmt/workorders/restoresafedeleted/${id}`, {}, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(workOrderActions.deleteItems(id));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(workOrderActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(workOrderActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(workOrderActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiWorkOrdersExportItem = async ({ id, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    if (capabilities.app.includes('exporter')) {
        dispatch(workOrderActions.startExporting());
    }

    await gestopAPI
        .get(`workmgmt/workorders/export/${id}`, { ...config, responseType: 'blob' })
        .then((response) =>
            batch(() => {
                window.open(URL.createObjectURL(response?.data));

                if (capabilities.app.includes('exporter')) {
                    dispatch(workOrderActions.stopExporting());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('exporter')) {
                    dispatch(workOrderActions.stopExporting());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(workOrderActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiWorkOrdersApplyTransItem = async ({
    id,
    transition = '',
    data = {},
    successCallback,
    errorCallback,
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(workOrderActions.startLoading());
    }

    await gestopAPI
        .post(`workmgmt/workorders/applytrans/${transition}/${id}`, data, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(workOrderActions.updateItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(workOrderActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(workOrderActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(workOrderActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiWorkOrdersLockItem = async ({
    id,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(workOrderActions.startLoading());
    }

    await gestopAPI
        .post(`workmgmt/workorders/lock/${id}`, {}, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(workOrderActions.updateItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(workOrderActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(workOrderActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(workOrderActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiWorkOrdersUnlockItem = async ({
    id,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(workOrderActions.startLoading());
    }

    await gestopAPI
        .post(`workmgmt/workorders/unlock/${id}`, {}, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(workOrderActions.updateItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(workOrderActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(workOrderActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(workOrderActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiWorkOrdersArchiveItem = async ({
    id,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(workOrderActions.startLoading());
    }

    await gestopAPI
        .post(`workmgmt/workorders/archive/${id}`, {}, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(workOrderActions.deleteItems(id));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(workOrderActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(workOrderActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(workOrderActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiWorkOrdersGetItem = async ({ id, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    if (capabilities.app.includes('loader')) {
        dispatch(workOrderActions.startLoading());
    }

    await gestopAPI
        .get(`workmgmt/workorders/${id}`, config)
        .then((response) =>
            batch(() => {
                if (capabilities.app.includes('loader')) {
                    dispatch(workOrderActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(workOrderActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(workOrderActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiWorkOrdersFileManagerIndex = async ({
    id,
    params = '',
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post(`workmgmt/workorders/filemanager/${id}?${params}`, data, {
            ...config,
            headers: { ...config?.headers } // Specific content type for file requests
        })
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiWorkOrdersFileManagerUpload = async ({
    id,
    params = '',
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post(`workmgmt/workorders/filemanager/upload/${id}?${params}`, data, {
            ...config,
            headers: { ...config?.headers, 'Content-Type': 'multipart/form-data' } // Specific content type for file requests
        })
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiWorkOrdersFileManagerDownload = async ({
    id,
    params = '',
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post(`workmgmt/workorders/filemanager/download/${id}?${params}`, data, { ...config, responseType: 'blob' })
        .then((response) => {
            if (response.status === 200) {
                const contentType = response.headers['content-type'];
                const contentDisposition = response.headers['content-disposition'];
                let fileName = 'names' in data ? data.names[0] : 'download';

                if (contentDisposition) {
                    const match = contentDisposition.match(/filename="(.+)"/);
                    if (match) {
                        fileName = match[1];
                    }
                }

                downloadFile(response.data, fileName, contentType);

                if (typeof successCallback === 'function') {
                    successCallback(response.data);
                }
            } else if (typeof errorCallback === 'function') {
                errorCallback();
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};
